// The list item: TipTap's, with every run of text in a tight item read as a
// paragraph.
//
// In a tight list marked gives an item's paragraphs as `text` tokens. TipTap
// wraps only the first one in a paragraph; a later one (the text after a code
// block in the same item) became bare text in the item, with its inline marks
// left as raw characters. The schema does not allow that: the live copy could
// not hold the item and dropped it whole. When a text run follows another
// block in the item, every text run is read as a paragraph instead, which is
// what the same item gives in a loose list. Items of one run are untouched.
import type { MarkdownToken } from "@tiptap/core";
import { ListItem } from "@tiptap/extension-list";

function hasStrayText(tokens: readonly MarkdownToken[]): boolean {
  return tokens.some(
    (t, i) => i > 0 && t.type === "text" && (t.tokens?.length ?? 0) > 0,
  );
}

// TipTap's reader is a plain function (no `this`), called as is.
const base = ListItem.config.parseMarkdown;

export const TrameriaListItem = ListItem.extend({
  parseMarkdown(token, helpers) {
    if (!base) return [];
    const tokens = token.tokens ?? [];
    if (!hasStrayText(tokens)) return base(token, helpers);
    return base(
      {
        ...token,
        tokens: tokens.map((t) =>
          t.type === "text" && (t.tokens?.length ?? 0) > 0
            ? { ...t, type: "paragraph" }
            : t,
        ),
      },
      helpers,
    );
  },
});
